import { useState } from 'react'
import SimulatedUpload from '$routes/KitchenSink/widgets/SimulatedUpload'
import KSColorsView from '$routes/KitchenSink/widgets/KSColorsView'
import ButtonsSection from '$routes/KitchenSink/widgets/ButtonsSection'
import AutoCompleteDropdown from '@components/shared/AutoCompleteDropdown'

const baseColors = []

for (let i = 50; i <= 500; i += 50) {
    baseColors.push(`bg-base-${i}`)
}

const people = [
    { id: 1, name: 'John Doe' },
    { id: 2, name: 'Jane Smith' },
    { id: 3, name: 'Bob Johnson' },
    { id: 4, name: 'Alice Brown' },
    { id: 5, name: 'Charlie Davis' },
]

const KSHome = () => {
    
    const [autoCompleteDropdownQuery, setAutoCompleteDropdownQuery] = useState('')
    const [autoCompleteDropdownSelectedPerson, setAutoCompleteDropdownSelectedPerson] = useState('')
    
    return (
        
        <div id="KSHome" className="pb-20">
            
            <div className="collapse bg-base-100 border-base-300 border" tabIndex={0}>
                <div className="collapse-title font-semibold">Base Colors</div>
                <div className="collapse-content flex flex-col gap-4">
                    
                    <div className="flex gap-10">
                        <KSColorsView/>
                        <KSColorsView useWhiteBg />
                    </div>
                    
                    <div>
                        <section>
                            <h4>Base Colors</h4>
                            <div className="base-colors">
                                {baseColors.map(it => (
                                    <div key={it} className={`${it} text-primary-content`}>{it}</div>
                                ))}
                            </div>
                        </section>
                        <section className="bg-gray-300">
                            <h4>Base Colors (Light Background)</h4>
                            <div className="base-colors">
                                {baseColors.map(it => (
                                    <div key={it} className={`${it} text-primary-content`}>{it}</div>
                                ))}
                            </div>
                        </section>
                    </div>
                
                </div>
            </div>
            
            <section className="collapse bg-base-100 border-base-300 border" tabIndex={1}>
                <div className="collapse-title font-semibold">Parse Colors</div>
                <div className="collapse-content">
                    <div className="parse-colors">
                        <div className="bg-parse-50 text-primary-content">parse-50</div>
                        <div className="bg-parse-100 text-primary-content">parse-100</div>
                        <div className="bg-parse-200 text-primary-content">parse-200</div>
                        <div className="bg-parse-300 text-primary-content">parse-300</div>
                        <div className="bg-parse-400 text-primary-content">parse-400</div>
                        <div className="bg-parse-500 text-primary-content">parse-500</div>
                        <div className="bg-parse-600 text-primary-content">parse-600</div>
                        <div className="bg-parse-700 text-primary-content">parse-700</div>
                        <div className="bg-parse-800 text-primary-content">parse-800</div>
                        <div className="bg-parse-900 text-primary-content">parse-900</div>
                        <div className="bg-parse-950 text-primary-content">parse-950</div>
                    </div>
                </div>
            </section>
            
            <div className="collapse bg-base-100 border-base-300 border" tabIndex={2}>
                <div className="collapse-title font-semibold">Buttons</div>
                <div className="collapse-content">
                    <ButtonsSection title="Default Buttons" />
                    <ButtonsSection title="Status Buttons" variation="status" />
                    <ButtonsSection title="Status Buttons" outline />
                    <ButtonsSection title="Status Buttons" variation="status" outline />
                </div>
            </div>
            
            <section className="flex gap-4 p-4">
                
                <div>
                    <h4>Inputs</h4>
                    <div className="flex flex-col gap-3 max-w-sm">
                        <input
                            className="input input-bordered input-xs"
                            type="text"
                            placeholder="input-xs"/>
                        <input
                            className="input input-bordered input-sm"
                            type="text"
                            placeholder="input-sm"/>
                        <input
                            className="input input-bordered input-md"
                            type="text"
                            placeholder="input-md"/>
                        <input
                            className="input input-bordered input-lg"
                            type="text"
                            placeholder="input-lg"/>
                    </div>
                </div>
                
                <div>
                    <h4>Dropdowns</h4>
                    <div className="flex flex-col gap-3 max-w-sm">
                        <AutoCompleteDropdown
                            items={people}
                            query={autoCompleteDropdownQuery}
                            setQuery={setAutoCompleteDropdownQuery}
                            selectedItem={autoCompleteDropdownSelectedPerson}
                            setSelectedItem={setAutoCompleteDropdownSelectedPerson}
                            displayValueKey="name"
                            onClose={() => setAutoCompleteDropdownQuery('')}
                            label="Organization"
                            placeholder="Search people..." />
                    </div>
                </div>
            
            </section>
            
            <section className="p-4">
                
                <div className="flex gap-4">
                    <SimulatedUpload />
                </div>
            
            </section>
        
        </div>
        
    )
    
}

export default KSHome
